import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const tagColors: { [key: string]: string } = {
  ai: 'bg-blue-100 text-blue-800',
  startups: 'bg-green-100 text-green-800',
  traveling: 'bg-purple-100 text-purple-800',
  other: 'bg-gray-100 text-gray-800',
  'Mobile App': 'bg-orange-100 text-orange-800',
  'EdTech': 'bg-indigo-100 text-indigo-800',
  'AI': 'bg-blue-100 text-blue-800',
  'Fundraising': 'bg-pink-100 text-pink-800'
};

interface BlogPost {
  title: string;
  description: string;
  date: string;
  tags: string[];
  slug: string;
  image?: string;
}

interface BlogListProps {
  selectedCategory: string | null;
}

export const BlogList: FC<BlogListProps> = ({ selectedCategory }) => {
  const posts: BlogPost[] = [
    {
      title: "Learnings of building & launching LarnU 👽",
      description: "LarnU was the \"duolingo\" for learning to code in just 5 minutes a day, right in your pocket.",
      date: "2025-04-18",
      tags: ["Mobile App", "EdTech", "AI", "Fundraising"],
      slug: "learnings-building-launching-larnu",
      image: "https://i.imgur.com/dn9GIUP.jpg"
    },
    // Add more blog posts here
  ];

  const filteredPosts = selectedCategory 
    ? posts.filter(post => post.tags.includes(selectedCategory))
    : posts;

  if (filteredPosts.length === 0) {
    return (
      <div className="text-center py-12">
        <h3 className="text-xl font-semibold mb-2">No posts found</h3>
        <p className="text-muted-foreground">
          No posts available for the selected category.
        </p>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredPosts.map((post, index) => (
          <Card key={index} className="overflow-hidden hover:shadow-lg transition-shadow">
            {post.image && (
              <div className="relative h-48 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="object-cover w-full h-full"
                />
              </div>
            )}
            <CardHeader>
              <CardTitle>
                <Link to={`/blog/${post.slug}`} className="hover:text-[#3b81f6] dark:hover:text-primary">
                  {post.title}
                </Link>
              </CardTitle>
              <CardDescription>{post.description}</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="flex flex-wrap gap-2 mb-4">
                {post.tags.map((tag, tagIndex) => (
                  <span
                    key={tagIndex}
                    className={`px-2 py-1 rounded-md text-sm font-medium ${
                      (tagColors as Record<string, string>)[tag] || 'bg-gray-100 text-gray-800'
                    }`}
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <div className="flex justify-between items-center">
                <time className="text-sm text-muted-foreground">
                  {new Date(post.date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </time>
                <Link 
                  to={`/blog/${post.slug}`}
                  className="text-[#3b81f6] hover:underline text-sm hover:text-[#3b81f6] dark:text-primary dark:hover:text-primary"
                >
                  Read More →
                </Link>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};